document.addEventListener("DOMContentLoaded", () => {
  

  addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".marquee").forEach(marquee => {
      const div = document.createElement("div")
      div.className = "marquee-sub"
      div.append(...marquee.children)
      marquee.append(div)
      marquee.append(div.cloneNode(true))
      const measure = div.cloneNode(true)
      measure.classList.add("marquee-measure")
      marquee.append(measure)
      if (marquee.dataset.speed) {
        marquee.dataset.marquee = Math.random()
        const style = document.createElement("style")
        style.textContent = `
          [data-marquee="${marquee.dataset.marquee}"].marquee.scrolling .marquee-sub {
            animation: marquee ${parseFloat(marquee.dataset.speed)}s linear infinite;
          }
        `
        document.body.appendChild(style)
      }
      marquee.classList.add("initialised")
      const adjust = () => marquee.classList.toggle("scrolling", measure.clientWidth > marquee.clientWidth)
      adjust()
      window.addEventListener("resize", adjust)
    })
  })  
  
  

  customElements.define("custom-select", class extends HTMLElement {
    connectedCallback() {
      const options = Array.from(this.querySelectorAll("option"))
      console.log("OPTIONS", options, this)
      const title = this.getAttribute("title") || "Select"
  
      this.classList.add("custom-select")
  
      const selected = document.createElement("div")
      selected.className = "selected"
  
      const label = document.createElement("span")
      label.className = "label"
      label.textContent = title
  
      const value = document.createElement("div")
      value.className = "select-option"
  
      const defaultValue = this.getAttribute("default")
      let defaultOption = options.find(o => o.value === defaultValue)
      
      // If default option is not available, find the first available option
      if (defaultOption && defaultOption.getAttribute("data-available") === "false") {
        defaultOption = options.find(o => o.getAttribute("data-available") !== "false")
      }
  
      if (defaultOption) {
        value.innerHTML = defaultOption.innerHTML
        value.setAttribute("data-available", defaultOption.getAttribute("data-available") || "true")
        this.value = defaultOption.value
        this.classList.add("selection")
      }
  
      const icon = document.createElement("div")
      icon.className = "select-icon"
      icon.innerHTML = `<svg width="24" height="24" viewBox="0 -960 960 960"><path d="M440-800v487L216-537l-56 57 320 320 320-320-56-57-224 224v-487h-80Z"/></svg>`
  
      selected.append(label, value, icon)
  
      const selectOptions = document.createElement("div")
      selectOptions.className = "select-options"
  
      // Check if there are any unavailable options
      const hasUnavailable = options.some(option => option.getAttribute("data-available") === "false")
      if (hasUnavailable) {
        this.classList.add("has-unavailable")
      }
  
      for (const option of options) {
        const div = document.createElement("div")
        div.className = "select-option"
        div.innerHTML = option.innerHTML
        const isAvailable = option.getAttribute("data-available") !== "false"
        div.setAttribute("data-available", isAvailable)
        
        if (isAvailable) {
          div.addEventListener("click", () => {
            value.innerHTML = option.innerHTML
            value.setAttribute("data-available", "true")
            this.value = option.value
            this.classList.remove("open")
            this.classList.add("selection")
            
            // Dispatch change event for variant updates
            this.dispatchEvent(new Event('change', { bubbles: true }))
          })
        }
        
        selectOptions.appendChild(div)
        const separator = document.createElement("div")
        separator.className = "select-option-separator"
        selectOptions.appendChild(separator)
      }
  
      this.addEventListener("click", e => {
        if (e.target.closest(".select-options")) return
        this.classList.toggle("open")
      })
  
      this.innerHTML = ""
      this.append(selected, selectOptions)
      
      // Method to update availability based on other selections
      this.updateAvailability = (variants) => {
        if (!variants || !this.hasAttribute("data-product-variants")) return
        
        const productVariants = JSON.parse(this.getAttribute("data-product-variants"))
        const optionPosition = parseInt(this.getAttribute("data-option-position"))
        
        // Get all custom-selects in the same container
        const container = this.closest('.upsell-bundle-variant-options-bundle')
        if (!container) return
        
        const allSelects = Array.from(container.querySelectorAll('custom-select'))
        const currentSelections = {}
        
        // Get current selections from other selects
        allSelects.forEach((select, index) => {
          if (select !== this && select.value) {
            currentSelections[index] = select.value
          }
        })
        
        // Update availability for each option
        const optionDivs = this.querySelectorAll('.select-options .select-option')
        options.forEach((option, index) => {
          const optionValue = option.value
          let isAvailable = false
          
          // Check if any variant with this option value is available
          for (const variant of productVariants) {
            if (variant.options[optionPosition] === optionValue && variant.available) {
              // Check if this variant matches other current selections
              let matchesOtherSelections = true
              for (const [pos, val] of Object.entries(currentSelections)) {
                if (variant.options[pos] !== val) {
                  matchesOtherSelections = false
                  break
                }
              }
              if (matchesOtherSelections) {
                isAvailable = true
                break
              }
            }
          }
          
          // Update the visual state
          if (optionDivs[index]) {
            optionDivs[index].setAttribute('data-available', isAvailable)
            if (!isAvailable) {
              // Remove click handler for unavailable options
              const newDiv = optionDivs[index].cloneNode(true)
              optionDivs[index].parentNode.replaceChild(newDiv, optionDivs[index])
            }
          }
        })
        
        // Update has-unavailable class
        const hasUnavailable = Array.from(optionDivs).some(div => 
          div.getAttribute('data-available') === 'false'
        )
        this.classList.toggle('has-unavailable', hasUnavailable)
      }
    }
  })
})